import * as React from "react";
import BorderedBox from "../SharedComponents/BorderedBox";
import { MenuItem, Select, Typography, makeStyles, Theme } from "@material-ui/core";
import { HandicapAdjustment } from "../../types/competition";

export interface HandicapAdjustmentsProps {
  handicapAdjustment?: HandicapAdjustment;
  onHandicapAdjustmentSelectChanged: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
  error: boolean;
  holesNumber: number;
}

const HandicapAdjustmentSection: React.FunctionComponent<HandicapAdjustmentsProps> = props => {
  const classes = useStyles();
  const { handicapAdjustment: rules, holesNumber } = props;

  if (holesNumber !== 9) {
    return null;
  }

  return (
    <BorderedBox title={"Handicap Adjustment"} variant={"h6"} error={props.error}>
      <div className={classes.inline}>
        <Typography variant={"subtitle1"}>Do you want apply WHS HI/2 adjustment?</Typography>
        <Select
          name="adjust9HolesRule"
          value={rules?.adjust9HolesRule ? 1 : 0}
          onChange={props.onHandicapAdjustmentSelectChanged}
        >
          <MenuItem value={1}>Yes</MenuItem>
          <MenuItem value={0}>No</MenuItem>
        </Select>
      </div>

      <div className={classes.inline}>
        <Typography variant={"subtitle1"}>Do you want apply Playing Handicap/2 adjustment ?</Typography>
        <Select
          name="adjust9HolesRulePH"
          value={rules?.adjust9HolesRulePH ? 1 : 0}
          onChange={props.onHandicapAdjustmentSelectChanged}
        >
          <MenuItem value={1}>Yes</MenuItem>
          <MenuItem value={0}>No</MenuItem>
        </Select>
      </div>
    </BorderedBox>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  inline: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export default HandicapAdjustmentSection;
